import React from 'react';
import { useParams } from 'react-router-dom';
import NewsLetterForm from './NewsLetterForm';
import { useGetNewsletterdetailsQuery } from '../../../../redux/apiSlice';

const EditNewsLetter = () => {
  const { id } = useParams();
  const { data: newsLetterData } = useGetNewsletterdetailsQuery(id);
  return (
    <div>
      <NewsLetterForm newsLetterData={newsLetterData} />
    </div>
  );
};

export default EditNewsLetter;
